import { onReady } from '../lib/on-ready.js';

function initCountdown() {
    document.querySelectorAll('.countdown-component').forEach((component) => {
        const setIframeTabIndex = () => {
            component.querySelectorAll('iframe').forEach((iframe) => {
                iframe.setAttribute('tabindex', '-1');
            });
        };

        const observer = new MutationObserver(() => {
            setIframeTabIndex();
            if (component.querySelector('iframe')) {
                observer.disconnect();
            }
        });

        observer.observe(component, { childList: true, subtree: true });

        component.querySelectorAll('script[src*="countdown"]').forEach((script) => {
            script.addEventListener('load', setIframeTabIndex, { once: true });
        });

        setIframeTabIndex();
    });
}

onReady(initCountdown);
